import React from 'react';
/**
 * Standard labelled input field with optional leading icon and right adornment.
 */
export function FormField({
  label,
  icon,
  right,
  hint,
  children
}: {
  label: string;
  icon?: React.ReactNode;
  right?: React.ReactNode;
  hint?: string;
  children: React.ReactNode;
}) {
  return <label className="block" data-id="element-375">
      <div className="mb-2" style={{
      fontSize: 13,
      fontWeight: 600,
      color: '#1A1A1A',
      letterSpacing: '0.02em'
    }} data-id="element-376">
        {label}
      </div>
      <div className="flex items-center gap-3 px-4 rounded-2xl bg-white transition-colors focus-within:border-[#009AC7]" style={{
      border: '1.5px solid #C0C0C0',
      minHeight: 56
    }} data-id="element-377">
        {icon && <div className="shrink-0" data-id="element-378">{icon}</div>}
        <div className="flex-1 min-w-0" data-id="element-379">{children}</div>
        {right && <div className="shrink-0" data-id="element-380">{right}</div>}
      </div>
      {hint && <div className="mt-1.5 ml-1" style={{
      fontSize: 12,
      color: '#7A7A7A',
      lineHeight: 1.5
    }} data-id="element-381">
          {hint}
        </div>}
    </label>;
}
export function FieldInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`w-full bg-transparent outline-none ${props.className ?? ''}`} style={{
    fontSize: 16,
    color: '#1A1A1A',
    minHeight: 52,
    fontWeight: 500,
    ...(props.style || {})
  }} data-id="element-382" />;
}
export function FieldSelect(props: React.SelectHTMLAttributes<HTMLSelectElement> & {
  children: React.ReactNode;
}) {
  return <select {...props} className={`w-full bg-transparent outline-none appearance-none ${props.className ?? ''}`} style={{
    fontSize: 16,
    color: '#1A1A1A',
    minHeight: 52,
    fontWeight: 500,
    ...(props.style || {})
  }} data-id="element-383">
      {props.children}
    </select>;
}